import {
  resetPasswordFailure,
  resetPasswordStart,
  resetPasswordSuccess,
  changeAdminPasswordStart,
  changeAdminPasswordSuccess,
  changeAdminPasswordFailure,
} from "../../reducer/ForgetPasswordReducer/ForgetPasswordReducer";
import { axiosInstance } from "../../../components/common/interceptor";
import {
  FORGET_PASSWORD_API,
  RESET_PASSWORD_API,
} from "../../../components/common/api";

// ............... Forget Password ....................
export const resetPassword = (email) => async (dispatch) => {
  dispatch(resetPasswordStart());
  try {
    const response = await axiosInstance.post(`${FORGET_PASSWORD_API}`, {
      email,
    });
    dispatch(resetPasswordSuccess(response.data));
    return response.data;
  } catch (error) {
    dispatch(
      resetPasswordFailure(
        error.response.data.message || "Failed to reset password"
      )
    );
    throw error;
  }
};

// .............. Reset passsword ..................


export const resetAdminPassword = async (newPassword, resetToken, dispatch) => {
  dispatch(resetPasswordStart());
  try {
    const response = await axiosInstance.patch(`${RESET_PASSWORD_API}?token=${resetToken}`,{ newPassword });

    dispatch(resetPasswordSuccess(response.data));
    return response.data;
  } catch (error) {
    dispatch(
      resetPasswordFailure(
        error.response?.data?.message || "Failed to reset password"
      )
    );
    throw error;
  }
}
// .............. Change Password .......................

export const changeAdminPassword = async (
  oldPassword,
  newPassword,
  dispatch
) => {
  dispatch(changeAdminPasswordStart());
  try {
    const response = await axiosInstance.patch(`${FORGET_PASSWORD_API}`, {
      oldPassword,
      newPassword,
      logout: false,
    });
    dispatch(changeAdminPasswordSuccess(response.data));
    return response.data;
  } catch (error) {
    dispatch(
      changeAdminPasswordFailure(
        error.response.data.message || "Failed to reset password"
      )
    );
    throw error;
  }
};
